<div class="progressbar-eva"></div>

<div class="container-eva">
  <!-- SIDEBAR / MENU -->
  <app-eva-sidebar
    [isMobile]="isMobile"
    [isMenuCollapsed]="isMenuCollapsed"
    [isMenuHovered]="isMenuHovered"
    [isMobileMenuToggled]="isMobileMenuToggled"
  >
  </app-eva-sidebar>

  <!-- CONTENT AREA -->
  <div class="content-eva" [class.collapsed]="isMenuCollapsed" [class.mobile]="isMobile">
    <!-- GLOBAL PROGRESS BAR -->
    <ng-container *ngIf="showGlobalLoader">
      <eva-progress class="global-progress-bar" size="small" [indeterminate]="true"></eva-progress>
    </ng-container>

    <div
      *ngIf="currentDiscount?.code && evaSubscription?.status === 'TRIAL' && evaSubscription?.formula_type !== 'EXPERT'"
      class="discount-banner"
      [ngStyle]="{ 'background-color': currentDiscount.background }"
    >
      <span style="margin: 5px 10px" class="title" [innerHTML]="currentDiscount.title"></span>
      <eva-button
        label="Découvrir"
        icon="heroSparkles"
        severity="secondary"
        size="small"
        (click)="openFormula()"
      ></eva-button>
      <button class="close-button" (click)="closeDiscountBar()">×</button>
    </div>

    <div *ngIf="evaSubscription?.formula_overage_blocked && !overageBannerClosed" class="discount-banner overage">
      <span style="margin: 5px 10px" class="title"
        >Vous avez dépassé le forfait gratuit EVA Pro (100'000 CHF facturés). La création de nouvelles factures clients
        est bloquée.</span
      >
      <eva-button
        label="Choisir une formule"
        icon="heroSparkles"
        severity="secondary"
        size="small"
        (click)="openOverageFormula()"
      ></eva-button>
      <button class="close-button" (click)="closeOverageBanner()">×</button>
    </div>

    <!-- MAIN CONTENT -->
    <div class="eva-main-content">
      <app-onboarding></app-onboarding>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Galet flottant : Tâches, Notes, Assistant et Conversations, une seule barre -->
<app-eva-notes-todos></app-eva-notes-todos>

<ngx-spinner bdColor="rgba(0,0,0,0.8)" size="large" color="#ffffff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">Chargement...</p>
</ngx-spinner>

<!-- Command Palette -->
<eva-command-palette
  #commandPalette
  [(visible)]="commandPaletteVisible"
  [sections]="commandPaletteSections"
  placeholder="Rechercher dans EVA..."
  [enableRecents]="true"
  [loading]="commandPaletteLoading"
  [emptyMessage]="commandPaletteEmptyMessage"
  [showShortcuts]="false"
  (onSearch)="onCommandPaletteSearch($event)"
  (onSelect)="onCommandPaletteSelect($event)"
  (onShow)="onCommandPaletteShow()"
  (onHide)="onCommandPaletteHide()"
></eva-command-palette>

<!-- <p-dialog
  *ngIf="upgradeFormulaPopup"
  [(visible)]="upgradeFormulaPopup"
  [style]="{ 'max-width': '1200px' }"
  [modal]="true"
  [closable]="true"
  [resizable]="false"
>
  <ng-template pTemplate="header">
    <div class="upgrade-formula-header">
      <img src="assets/img/brand/logo.png" alt="Icone" class="header-icon" />
      <span class="header-title">Essayez une autre formule</span>
      <ng-icon name="heroXMark" class="close-icon" (click)="closeUpgradeFormula()"></ng-icon>
    </div>
  </ng-template>

  <div style="padding: 0px 50px 50px 50px">
    <app-formula-list
      [evaSubscription]="evaSubscription"
      [formulaRecommended]="evaSubscription.formula"
    ></app-formula-list>
  </div>
</p-dialog> -->

<app-formula-popup></app-formula-popup>

<!-- Centre d'aide global (piloté par EvaHelpService) -->
<eva-help-drawer></eva-help-drawer>
